import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FaArrowRight } from "react-icons/fa";

const ThankYouPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Thank You | Beyond Bloom</title>
        <meta
          name="description"
          content="Thank you for reaching out to Beyond Bloom. Your message has been received, and we'll get back to you within 24 hours."
        />
      </Helmet>

      <Navbar />

      <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-b from-gray-950 via-black to-gray-950 text-white text-center p-6 relative overflow-hidden">
        {/* Glowing Background Elements */}
        <div className="absolute inset-0 flex justify-center items-center">
          <div className="w-96 h-96 bg-green-500 opacity-20 blur-[150px] animate-pulse"></div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative bg-black p-12 rounded-3xl shadow-2xl max-w-3xl w-full border border-gray-800 flex flex-col items-center backdrop-blur-xl bg-opacity-80"
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="w-24 h-24 bg-gradient-to-r from-green-400 to-green-400 flex justify-center items-center rounded-full shadow-xl border-4 border-green-400"
          >
            <FaArrowRight className="text-4xl text-white" />
          </motion.div>

          <motion.h1
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
            className="text-5xl font-extrabold mb-4 text-white tracking-wide drop-shadow-lg"
          >
            Thank You!
          </motion.h1>
          <p className="text-lg mb-4 text-gray-300 max-w-lg leading-relaxed">
            We’ve received your message and will get back to you within{" "}
            <span className="font-bold text-green-400">24 hours</span>.
          </p>
          <p className="text-md text-gray-400 mb-6 max-w-md">
            Need urgent help? Connect with us on social media or call us
            directly.
          </p>

          <motion.button
            whileHover={{
              scale: 1.1,
              boxShadow: "0px 0px 20px rgba(72, 255, 151, 0.8)",
            }}
            whileTap={{ scale: 0.9 }}
            onClick={() => navigate("/")}
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-green-400 text-black rounded-lg font-semibold text-lg hover:bg-green-500 transition duration-300"
          >
            Back to Home <FaArrowRight />
          </motion.button>
        </motion.div>
      </div>

      <Footer />
    </>
  );
};

export default ThankYouPage;
